import {
  getAllNestedChildrenValues,
  isOnlySiblingSelected,
  isOnlyNestedSelected,
} from 'search/utils/categoryFilterUtils';

export const getCategoryFilterQuery = (routerQuery, category, categoryFacet) => {
  const queryObject = { ...routerQuery };
  const existingFacetTypes = Object.keys(queryObject);
  const categoryValue = category.value;
  const categoryParent = category?.data?.parent;
  const selectedAllNestedChildrenValues = getAllNestedChildrenValues(category);

  // category filter already applied
  if (existingFacetTypes.includes('web_groups')) {
    const categoryFiltersApplied = Array.isArray(queryObject.web_groups)
      ? queryObject.web_groups
      : [queryObject.web_groups];

    // if current category already selected, remove it to deselect it
    if (categoryFiltersApplied.includes(categoryValue)) {
      const currentCategoryRemoved = categoryFiltersApplied.filter((cat) => cat !== categoryValue);
      // find current category's parent in categoryFacet and if only 1 of the parent's children is selected then remove current category and add parent
      if (isOnlyNestedSelected(categoryFacet, categoryParent)) {
        queryObject.web_groups = [...currentCategoryRemoved, categoryParent];
      } else {
        // remove it to deselect it
        queryObject.web_groups = currentCategoryRemoved;
      }
    } else if (categoryFiltersApplied.includes(categoryParent)) {
      // if currently selected categories already includes current category's parent, then remove the parent from filters
      const parentRemoved = categoryFiltersApplied.filter((cat) => cat !== categoryParent);
      queryObject.web_groups = [...parentRemoved, categoryValue];
    } else if (
      categoryFiltersApplied.some((cat) => selectedAllNestedChildrenValues.includes(cat))
    ) {
      // if currently selected categories includes any of current category's children, unselect all its children
      const allNestedChildrenRemoved = categoryFiltersApplied.filter(
        (cat) => !selectedAllNestedChildrenValues.includes(cat),
      );
      // find current category's parent in categoryFacet and if only 1 of the parent's children is selected then remove current category and add parent
      if (isOnlySiblingSelected(categoryFacet, categoryParent)) {
        queryObject.web_groups = [...allNestedChildrenRemoved, categoryParent];
      } else {
        queryObject.web_groups = [...allNestedChildrenRemoved];
      }
    } else {
      // category is not already selected, add it to select it
      queryObject.web_groups = [...categoryFiltersApplied, categoryValue];
    }
  } else {
    // no category filter currently applied, add `web_groups` to filter with current category value
    queryObject.web_groups = categoryValue;
  }

  return queryObject;
};
